import * as s from '~/lib/normalize/schema';
import { OrganizationSchema, LocationSchema, TransactionSchema } from '~/apps/shared/apis/schemas';

// TODO to shared folder

// Paycodes
export const PaycodeSchema = s.obj({
  id: s.field(),
  organizationId: s.alias('constraints.organization_id'),
  organization: s.alias('constraints.organization', OrganizationSchema),
  locationId: s.alias('constraints.location_id'),
  location: s.alias('constraints.location', LocationSchema),
  date: s.date(),
  amount: s.alias('constraints.amount.value', s.currency()),
  used: s.currency(),
  status: s.field(),
  statusReason: s.alias('status_reason'),
  code: s.field(),
  note: s.field(),
  transactionId: s.alias('transaction_id'),
  transaction: TransactionSchema,
});

export const PaycodeListSchema = s.list(PaycodeSchema);

export const PaycodeRequest = s.obj({
  amount: s.currency(),
  code: s.field(),
  organizationId: s.alias('organization_id'),
  locationId: s.alias('location_id'),
  note: s.field(),
});

export const PaycodeAttempRequest = s.obj({
  amount: s.currency(),
  code: s.field(),
  locationId: s.alias('location_id'),
});

